module.exports = {
  QCInfo: {
    prod: {
      appId: '102027232',
      redirect_url: 'https://guanjia.qq.com/software-platform/proxy',
      login_url:
        'https://graph.qq.com/oauth2.0/authorize?response_type=code&client_id=102027232&redirect_uri=https://guanjia.qq.com/software-platform/proxy',
      verify_url:
        'https://graph.qq.com/oauth2.0/authorize?response_type=code&client_id=102027232&redirect_uri=https://guanjia.qq.com/software-platform/verify'
    },
    beta: {
      appId: '102029246',
      redirect_url:
        'https://guanjia.sparta.html5.qq.com/software-platform/proxy',
      login_url:
        'https://graph.qq.com/oauth2.0/authorize?response_type=code&client_id=102029246&redirect_uri=https://guanjia.sparta.html5.qq.com/software-platform/proxy',
      verify_url:
        'https://graph.qq.com/oauth2.0/authorize?response_type=code&client_id=102029246&redirect_uri=https://guanjia.sparta.html5.qq.com/software-platform/verify'
    }
  }
};
